import AdminModalNew from "../../../components/AdminModalNew";
import {
  CloseIcon,
} from "../../../../icons";


const SubmitConfirmationModal = ({ show, onClose, onSaveAsDraft, onSubmit, onDiscard, isEdit = false }) => {
  return (
    <AdminModalNew show={show} size="modal-lg" centered={true} onClose={onClose}>
      <h5 className="tw:!text-center tw:!text-[20px] tw:!font-[600] tw:!text-[#4E4E4E] tw:!mb-8">
        {isEdit ? "Would you like to update the quotation?" : "Would you like to activate the quotation?"}
      </h5>

      {
        isEdit ? (
          <div className="tw:!flex tw:!justify-between tw:!items-center">
            <button
              type="button"
              onClick={onDiscard}
              className="tw:!flex tw:!items-center tw:!gap-2 tw:!py-3 tw:!px-8 tw:!rounded-md tw:!text-[#EA4335] tw:!font-[400] tw:!text-[15px] tw:!bg-[#FFEAE7] tw:!transition-colors tw:!cursor-pointer"
            >
              <CloseIcon color="#EA4335" size={10} />
              Discard Edit
            </button>
            <div className="tw:!flex tw:!gap-2">
              <button
                type="button"
                onClick={onClose}
                className="tw:!py-3 tw:!px-8 tw:!border-[1.5px] tw:!border-[#D9D9D9] tw:!rounded-md tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!bg-white tw:!transition-colors tw:!cursor-pointer"
              >
                Continue Editing
              </button>
              <button
                type="button"
                onClick={onSubmit}
                className="tw:!py-3 tw:!px-12 tw:!rounded-md tw:!text-white tw:!font-[400] tw:!text-[15px] tw:!bg-[#DBBE78] tw:!transition-colors tw:!cursor-pointer"
              >
                Update
              </button>
            </div>
          </div>
        ) : (
          <div className="tw:!flex tw:!justify-between tw:!items-center">
            <div className="tw:!flex tw:!gap-2">
              <button
                type="button"
                onClick={onClose}
                className="tw:!py-3 tw:!px-8 tw:!border-[1.5px] tw:!border-[#D9D9D9] tw:!rounded-md tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!bg-white tw:!transition-colors tw:!cursor-pointer"
              >
                Continue Editing
              </button>
              <button
                type="button"
                onClick={onSaveAsDraft}
                className="tw:!py-3 tw:!px-8 tw:!rounded-md tw:!text-white tw:!font-[400] tw:!text-[15px] tw:!bg-[#8D8D8D] tw:!transition-colors tw:!cursor-pointer"
              >
                Save As Draft
              </button>
            </div>
            <button
              type="button"
              onClick={onSubmit}
              className="tw:!py-3 tw:!px-12 tw:!rounded-md tw:!text-white tw:!font-[400] tw:!text-[15px] tw:!bg-[#3CAEA3] tw:!transition-colors tw:!cursor-pointer"
            >
              Activate
            </button>
          </div>
        )
      }
    </AdminModalNew>
  );
};

export default SubmitConfirmationModal;
